<div
  [ngClass]="displayOnTopBar() ? 'conversation-title-top-bar' : 'conversation-title-preview'"
  [class.closed-or-deleted]="isInternalInfoDeleted() || conversationClosed()"
  title="{{ title() || '' | glxyPhoneNumber | translate }}"
>
  {{ title() || '' | glxyPhoneNumber | translate }}
</div>
